'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'radio-button',
    elem: 'control',
    tag: 'input',
    attrs: function attrs(_ref) {
        var disabled = _ref.disabled,
            id = _ref.id,
            name = _ref.name,
            checked = _ref.checked,
            value = _ref.value,
            onChange = _ref.onChange,
            innerRef = _ref.innerRef;

        return {
            type: 'radio',
            tabIndex: disabled ? '-1' : undefined,
            ref: innerRef,
            checked: checked,
            disabled: disabled,
            onChange: onChange,
            value: value,
            name: name,
            id: id
        };
    }
}, {
    propTypes: {
        innerRef: _propTypes2.default.func
    }
});